
import { useContext } from 'react';
import { RootStore } from '../store';
import { StoreContext } from '../contexts'

export const useStores = (): RootStore => useContext(StoreContext);


